// extracted by mini-css-extract-plugin
module.exports = {"logo":"_BG-0v4PY","buttonFullWidth":"_gySEoBfD"};